module.exports = __webpack_public_path__ + "img/logo-smg.5ffeb19e.png";